import React from 'react';

import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Align from '@marvelapp/marvel-ui/align';

import IntegrationsCta from 'marketing-website/components/modules/IntegrationsCta';
import Whitespace from 'marketing-website/components/commons/Whitespace';
import Page from 'marketing-website/components/modules/Page';

import items from 'marketing-website/configs/pages/labs/items.js';
import metaData from 'marketing-website/data/metadata.js';

import LabsCard from './card';

export default function Labs() {
  const gridItems = items.map(item => (
    <GridItem columnSpan={3} columnSpanM={1} key={item.id}>
      <MaxWidth value={387}>
        <LabsCard {...item} />
      </MaxWidth>
    </GridItem>
  ));

  return (
    <Page
      title={metaData.labs.title}
      meta={[
        {
          name: 'description',
          content: metaData.labs.description,
        },
        {
          name: 'keywords',
          content: metaData.labs.keywords,
        },
      ]}
      header
      footer
    >
      <PageWrap size="l">
        <Whitespace size="s" sizeS="l" sizeM="xl" />
        <Align type="center" typeM="left">
          <MaxWidth value={520}>
            <Heading tag="h1" weight="semibold" size="mega">
              Labs
            </Heading>
          </MaxWidth>
          <Spacing size="s" type="padding" position="topBottom">
            <MaxWidth value={520}>
              <Paragraph size="xxxl" color="slate">
                Collection of articles, open source projects and resources made
                by people at Marvel.
              </Paragraph>
            </MaxWidth>
          </Spacing>
          <Spacing size="l" type="padding" position="topBottom">
            <Grid columns={3} size="m" sizeM="l" sizeL="xl">
              {gridItems}
            </Grid>
          </Spacing>
        </Align>
      </PageWrap>

      <IntegrationsCta />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/labs/index.js